import React from "react";
import { useEffect } from "react";
import "./ScrollTop.css";

function ScrollTop() {
  //   const listenScrollEvent = () => {
  //     window.scrollY > 60
  //       ? document.getElementById("return-to-top").fadeIn(200)
  //       : // setnavColor("#252734")
  //         document.getElementById("return-to-top").fadeOut(200);
  //   };
  //   useEffect(() => {
  //     window.addEventListener("scroll", listenScrollEvent);
  //     return () => {
  //       window.removeEventListener("scroll", listenScrollEvent);
  //     };
  //   }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <a onClick={scrollToTop} href="javascript:" id="return-to-top">
        <i class="icon-chevron-up"></i>
      </a>
    </div>
  );
}

export default ScrollTop;
